import ReactDOM from 'react-dom';
import { array, bool, func, object, string } from 'prop-types';
import logExploreSearchBoxClicked from '@alltrails/analytics/events/logExploreSearchBoxClicked';
import logSearchResultClicked from '@alltrails/analytics/events/logSearchResultClicked';
import SearchSuggestionSelectionType from '@alltrails/analytics/enums/SearchSuggestionSelectionType';
import SearchResultList from 'components/search/SearchResultList';
import { AlgoliaResultType } from 'types/Search/Algolia';
import { algoliaTypeToAmplitudeType } from 'utils/amplitudeHelper';
import { LOCATION_PAGE } from 'utils/constants/SearchAnalyticsConstants';
import { DEFAULT_RADIUS_METERS, legacyAlgoliaSearchBoxQuery } from 'utils/legacyAlgoliaSearchQuery';
import { SearchFilterMenu } from '../../application/javascripts/react_components/search/search_filter_menu';
import { SearchResultsUtil } from '../../utils/search_results_util';
import { LanguageSupportUtil } from '../../utils/language_support_util';
import { StringConstantsMixin } from '../../application/javascripts/react_components/mixins/shared/string_constants_mixin';
import { saveAlgoliaQueryIdsToLocalStorage, sendSearchResultsBeacon } from '../../utils/requests/algolia_requests';
import logError from '../../utils/logError';
import { getAlgoliaIndex } from '../../utils/search';
import { debounce } from 'debounce';

import * as styles from './styles/styles.module.scss';

const createReactClass = require('create-react-class');

const LIST_WEIGHT_FACTOR = 100; // Used to bring entries in a list to the top of Did You Mean...?

const getFilters = typeSubset => {
  const filters = {
    all: 'all',
    place: 'places',
    area: 'parks',
    trail: 'trails',
    map: 'maps',
    track: 'recordings',
    list: 'lists'
  };

  return Object.keys(filters).reduce((result, key) => {
    const isAllowed = typeSubset?.length === 0 || typeSubset?.indexOf(key) !== -1;
    if (isAllowed) {
      result[key] = filters[key];
    }
    return result;
  }, {});
};

const AlgoliaSearchBox = createReactClass({
  componentDidMount() {
    this.algoliaIndex = getAlgoliaIndex(this.props.algoliaIndexId, this.props.languageRegionCode);
    this.debouncedSearch = debounce(filterType => {
      this.handleSearch(filterType);
    }, 250);

    // Click events are on document because onBlur does not capture relatedTarget properly
    // This is needed to keep the results dropdown open when no longer focused on input.
    $(document).on('click touchstart', this.handleClick);
    $(document).on('keydown', this.handleKeyDown);
  },
  getInitialState() {
    return {
      currentFilter: Object.keys(getFilters(this.props.typeSubset))[0],
      currentSearchId: null,
      currentSelection: -1,
      enableClickTracking: true,
      firstInput: false,
      itemClicked: false,
      results: [],
      searchTerm: '',
      shouldShow: false
    };
  },
  handleFilter(filterType) {
    this.setState({ currentFilter: filterType, currentSelection: -1 });
    this.handleSearch(filterType);
  },
  handleSubmit(btnClicked, e) {
    e.preventDefault();
    e.stopPropagation();
    const currentSelection = this.state.currentSelection;
    if (currentSelection >= 0 && currentSelection < this.state.results.length && !btnClicked) {
      const obj = this.state.results[currentSelection];
      // TODO https://alltrails.atlassian.net/browse/TD-300
      const { slug, type } = obj;
      let url;
      if (type === 'place' || type === 'area') {
        url = `/${slug}/all?ref=search`;
      } else if (type === 'trail') {
        const dataUrl = `/${slug}`;
        url = `${dataUrl}?ref=search`;
        this.handleItemClick(url, obj, currentSelection);
        return false;
      } else if (type === 'track') {
        url = `/explore/recording/${slug}`;
      } else if (type === 'map') {
        url = `/explore/map/${slug}`;
      }
      this.handleItemClick(url, obj, currentSelection);
      return false;
    }
    if (this.props.allowStringSearch) {
      const searchTerm = this.refs.searchInput.value;
      this.props.handleQueryStringSubmit(searchTerm);
      this.refs.searchInput.blur();
      this.refs.searchInput.value = '';
      this.setState({ shouldShow: false, searchTerm: '' });
      return false;
    }
    const searchTerm = this.refs.searchInput.value;
    const latLng = this.getLatLng(searchTerm);
    if (latLng) {
      this.handleLatLngSearch(latLng);
      this.setState({ shouldShow: false, searchTerm: '' });
      return false;
    }
    // If the user entered an empty search, go to explore
    if (searchTerm == '' && (this.props.typeSubset?.length === 0 || this.props.typeSubset[0] == 'all')) {
      window.location = LanguageSupportUtil.wrapUrlSafe('/explore', this.props.languageRegionCode);
      return false;
    }
    if (this.props.liveStringSearch && btnClicked) {
      return false;
    }
    this.setState({ didYouMeanActive: true, searchTerm });
    return false;
  },
  getLatLng(searchTerm) {
    const reg = new RegExp('^(\\(?)([-+]?)([\\d]{1,2})((\\.)(\\d+))?(,\\s*)(([-+]?)([\\d]{1,3})((\\.)(\\d+))?(\\)?))$');
    if (!reg.exec(searchTerm)) {
      return null;
    }
    const latLng = searchTerm.replace('(', '').replace(')', '').replace(' ', '').split(',');
    return latLng.length == 2 ? latLng : null;
  },
  handleLatLngSearch(latLng) {
    const lat = parseFloat(latLng[0]);
    const lng = parseFloat(latLng[1]);
    if (!Number.isNaN(lat) && !Number.isNaN(lng) && lat >= -90 && lat <= 90 && lng >= -180 && lng <= 180) {
      if (this.props.messagingChannel) {
        this.props.messagingChannel.publish({
          topic: 'edit.change_lat_lng',
          data: [lat, lng]
        });
      }
    }
  },
  handleSearch(filterType) {
    // Don't bother performing algolia search
    if (this.props.liveStringSearch) {
      return;
    }
    const searchTerm = this.refs.searchInput.value;
    this.setState({ searchTerm });

    legacyAlgoliaSearchBoxQuery({
      algoliaIndex: this.algoliaIndex,
      context: {
        currentUser: this.props.currentUser,
        languageRegionCode: this.props.languageRegionCode,
        mobileBrowser: this.props.mobileBrowser
      },
      enableClickTracking: this.state.enableClickTracking,
      filterType,
      latLng: searchTerm.length === 0 ? this.props.defaultLatLng : this.getLatLng(searchTerm),
      origin: this.props.page,
      searchTerm,
      typeSubset: this.props.typeSubset
    })
      .then(this.handleSearchResults)
      .catch(logError);
  },
  handleInput(e) {
    if (e.keyCode == 38 || e.keyCode == 40) {
      e.preventDefault();
      return false;
    }
    const term = this.refs.searchInput.value;
    // Live-filter results as search term changes when in string-search mode
    if (this.props.liveStringSearch) {
      this.props.handleQueryStringSubmit(term);
      return true;
    }
    if (this.state.searchTerm != term) {
      this.debouncedSearch(this.state.currentFilter);
    }
    if (term != '') {
      let { firstInput } = this.state;
      if (!firstInput) {
        firstInput = true;
      }
      this.setState({ shouldShow: true, firstInput });
    }
    return true;
  },
  weightSearchResultsByListItems(results) {
    return results
      .map(result => {
        if (this.props.listTrailIds.includes(result.ID)) {
          if (result.adjustedPopularity) result.adjustedPopularity *= LIST_WEIGHT_FACTOR;
          else result.adjustedPopularity = result.popularity * LIST_WEIGHT_FACTOR;
        } else {
          result.adjustedPopularity = result.popularity;
        }
        return result;
      })
      .sort((a, b) => b.adjustedPopularity - a.adjustedPopularity);
  },
  handleSearchResults(content) {
    // save queryID for conversion tracking
    let { currentSearchId } = this.state;
    if (content.queryID) {
      currentSearchId = content.queryID;
    }

    let results;
    if (this.props.citiesOnly) {
      results = content.hits.filter(item => item.objectID.indexOf('cityo-') > -1);
    } else if (this.props.weightResults && !this.state.searchTerm && this.props.defaultLatLng && this.props.defaultLatLng.length == 2) {
      // If we don't have a search term, instant drop down sorts by default lat/lng
      // If we do have a search term, just search by search term
      results = SearchResultsUtil.createWeightedResultList(content.hits, this.props.defaultLatLng, DEFAULT_RADIUS_METERS);
    } else {
      results = content.hits;
    }

    // If we have a set of list trail ids, try to sort them to the top
    if (this.props.listTrailIds && this.props.listTrailIds.length > 0) {
      results = this.weightSearchResultsByListItems(results);
    }

    this.setState({ currentSearchId, shouldShow: true, results, currentSelection: -1 });
  },
  handleFocus() {
    // String-search filters results live and doesn't show dropdown
    if (this.props.liveStringSearch) {
      return;
    }
    if (this.refs.searchInput.value != '') {
      this.setState({ shouldShow: true });
    }
  },
  handleInputFocus() {
    const { page, onLocationPage } = this.props;
    logExploreSearchBoxClicked({ search_origin: onLocationPage ? LOCATION_PAGE : page });
    this.handleSearch.bind(null, this.state.currentFilter)();
  },
  handleKeyDown(e) {
    if (!this.state.shouldShow || (e.keyCode != 38 && e.keyCode != 40)) return true;
    if (this.state.shouldShow && e.keyCode == 38) {
      if (this.state.currentSelection < 1) {
        $(this.refs.searchInput).focus();
      }
      if (this.state.currentSelection >= 0) {
        this.setState({ currentSelection: this.state.currentSelection - 1 });
      }
    } else if (this.state.shouldShow && e.keyCode == 40 && this.state.currentSelection < this.state.results.length) {
      this.setState({ currentSelection: this.state.currentSelection + 1 });
    }
    e.preventDefault();
    return false;
  },
  handleClick(e) {
    if ($(e.target).parents('.algolia-search').length == 0 && this.state.shouldShow == true) {
      this.refs.searchInput.blur();
      this.setState({ shouldShow: false, currentSelection: 0 });
    }
  },
  reportClickEvent(url, item, position) {
    const queryId = this.state.currentSearchId;
    const userId = this.props.currentUser ? this.props.currentUser.id : null;
    const index = this.props.algoliaIndexId;

    sendSearchResultsBeacon(item.objectID, index, position + 1, queryId, userId, this.props.page);
    saveAlgoliaQueryIdsToLocalStorage(queryId, item.objectID);
    this.handleItemClick(url, item, position);
  },
  handleHover(i) {
    this.setState({ currentSelection: i });
  },
  closeColorbox() {
    if (!this.state.cboxOpen) {
      return;
    }

    $.colorbox.close();
  },
  handleItemClick(url, item, position) {
    this.refs.searchInput.blur();
    const { cboxOpen } = this.state;

    if (!item) {
      window.location.href = url;
      return false;
    }

    const searchTab = getFilters(this.props.typeSubset)[this.state.currentFilter];

    logSearchResultClicked({
      click_position: position,
      content_id: item.objectID.split('-')[1],
      item_type: algoliaTypeToAmplitudeType(item?.type),
      location: this.props.page,
      query_length: this.state.searchTerm ? this.state.searchTerm.length : 0,
      selection_type: SearchSuggestionSelectionType.SearchSuggestion,
      search_tab: searchTab
    });

    if (item.type == AlgoliaResultType.Trail && this.props.handleTrailSelect) {
      this.refs.searchInput.value = '';
      // Allow search box to set state and then get unmounted by container app
      this.setState({ searchTerm: '', shouldShow: false, itemClicked: cboxOpen }, () => {
        this.props.handleTrailSelect(item);
        this.closeColorbox();
      });
      return false;
    }
    if (item.type == AlgoliaResultType.Area && this.props.handleAreaSelect) {
      this.refs.searchInput.value = '';
      this.props.handleAreaSelect(item);
      this.setState({ searchTerm: '', shouldShow: false, itemClicked: cboxOpen }, this.closeColorbox);
      return false;
    }
    if ([AlgoliaResultType.Place, AlgoliaResultType.Filter, AlgoliaResultType.POI].includes(item.type) && this.props.handleLocationSelect) {
      this.refs.searchInput.value = '';
      this.props.handleLocationSelect(item);
      this.setState({ searchTerm: '', shouldShow: false, itemClicked: cboxOpen }, this.closeColorbox);
      return false;
    }
    if (item.type == AlgoliaResultType.List && this.props.onSearchPage) {
      window.open(url, '_blank');
      this.setState({ shouldShow: false, itemClicked: cboxOpen }, this.closeColorbox);
      return false;
    }

    if (this.props.onMapPage) {
      window.open(url, '_self');
      this.setState({ shouldShow: false, itemClicked: cboxOpen }, this.closeColorbox);
      return false;
    }

    if (this.props.onSearchPage) {
      window.open(url, '_blank');
      this.setState({ shouldShow: false, itemClicked: cboxOpen }, this.closeColorbox);
      return false;
    }

    this.setState({ itemClicked: cboxOpen }, this.closeColorbox);
    window.location.href = url;
  },
  renderColorboxResults() {
    if (this.state.results && this.state.results.length > 0) {
      ReactDOM.render(this.renderFilterMenu(), document.getElementById('did-you-mean-filters'));
    }
    ReactDOM.render(this.renderResultsList(), document.getElementById('did-you-mean-list'));
  },
  componentDidUpdate() {
    if (!this.state.didYouMeanActive) {
      return;
    }
    if (this.state.cboxOpen) {
      this.renderColorboxResults();
      return;
    }
    let baseHtmlString;
    if (this.state.results && this.state.results.length > 0)
      baseHtmlString = `<div id='did-you-mean'><div class='text-header'>${StringConstantsMixin.strings.SEARCH.DID_YOU_MEAN}</div><div id='did-you-mean-filters'></div><div id='did-you-mean-list'></div><div class='support-text'>${StringConstantsMixin.strings.SEARCH.DONT_SEE} <a href='mailto:support@alltrails.com'>${StringConstantsMixin.strings.SEARCH.CONTACT_US}</a></div></div>`;
    else {
      baseHtmlString = `<div id='did-you-mean'><div class='text-header no-result'>${StringConstantsMixin.strings.SEARCH.SORRY_CANT_FIND} "${this.state.searchTerm}". ${StringConstantsMixin.strings.SEARCH.PLEASE_TRY_AGAIN}</div><div id='did-you-mean-list'></div><div class='support-text no-result'>${StringConstantsMixin.strings.SEARCH.DONT_SEE} <a href='mailto:support@alltrails.com'>${StringConstantsMixin.strings.SEARCH.CONTACT_US}</a></div></div>`;
    }
    $.colorbox({
      html: baseHtmlString,
      width: 350,
      height: 600,
      onComplete: () => {
        this.setState({ cboxOpen: true });
        this.renderColorboxResults();
      },
      onClosed: () => {
        this.setState(
          {
            currentSelection: -1,
            didYouMeanActive: false,
            cboxOpen: false,
            shouldShow: false,
            itemClicked: false
          },
          this.state.itemClicked ? null : () => this.refs.searchInput.focus()
        );
      }
    });
  },
  renderFilterMenu() {
    const filters = getFilters(this.props.typeSubset);
    if (Object.keys(filters).length <= 1) {
      return null;
    }
    return (
      <SearchFilterMenu
        filters={filters}
        filterOrder={Object.keys(filters)}
        filterSelected={this.handleFilter}
        currentFilter={this.state.currentFilter}
      />
    );
  },
  renderResultsList() {
    return (
      <SearchResultList
        currentSelection={this.state.currentSelection}
        handleResultHover={this.handleHover}
        items={this.state.results}
        mobileBrowser={this.props.mobileBrowser}
        languageRegionCode={this.props.languageRegionCode}
        currentUser={this.props.currentUser}
        homePage={this.props.homePage}
        handleItemClick={this.state.enableClickTracking ? this.reportClickEvent : this.handleItemClick}
        displayMetric={this.props.displayMetric}
        latLngForDisplayDistance={this.props.displayDistanceToLatLng ? this.props.defaultLatLng : null}
      />
    );
  },
  renderResults() {
    if (!this.state.shouldShow || this.state.didYouMeanActive) {
      return null;
    }
    return (
      <div className="result-list">
        {this.renderFilterMenu()}
        {this.renderResultsList()}
      </div>
    );
  },
  render() {
    return (
      <form
        className={`algolia-search ${styles.form} ${this.props.className}`}
        data-testid="algoliaTextBox"
        onFocus={this.handleFocus}
        onSubmit={this.handleSubmit.bind(null, false)}
      >
        <input
          aria-label={this.props.placeholderText || StringConstantsMixin.strings.SEARCH.ENTER_CITY_PARK_OR_TRAIL_NAME}
          autoComplete="off"
          autoCorrect="off"
          data-testid="algoliaPlaceholderText"
          className={styles.input}
          onFocus={this.handleInputFocus}
          onKeyUp={this.handleInput}
          placeholder={this.props.placeholderText || StringConstantsMixin.strings.SEARCH.ENTER_CITY_PARK_OR_TRAIL_NAME}
          ref="searchInput"
          spellCheck="false"
          type="text"
        />
        <input
          arial-label={StringConstantsMixin.strings.SEARCH_WORD}
          className={`${styles.btn}  ${this.props.searchIconButton ? styles.icon : ''}`}
          data-testid="algoliaSearchButton"
          onClick={this.handleSubmit.bind(null, true)}
          title={StringConstantsMixin.strings.SEARCH_WORD}
          type="submit"
          value={this.props.searchIconButton ? '' : StringConstantsMixin.strings.SEARCH_WORD}
        />
        {this.renderResults()}
      </form>
    );
  }
});

AlgoliaSearchBox.propTypes = {
  algoliaIndexId: string,
  allowStringSearch: bool,
  citiesOnly: bool,
  className: string,
  currentUser: object,
  displayDistanceToLatLng: bool,
  defaultLatLng: array,
  displayMetric: bool,
  handleAreaSelect: func,
  handleLocationSelect: func,
  handleQueryStringSubmit: func,
  handleTrailSelect: func,
  homePage: bool,
  languageRegionCode: string,
  listTrailIds: array,
  liveStringSearch: bool,
  messagingChannel: object,
  mobileBrowser: bool,
  onLocationPage: bool,
  onMapPage: bool,
  onSearchPage: bool,
  page: string.isRequired,
  placeholderText: string,
  searchIconButton: bool,
  typeSubset: array,
  weightResults: bool
};

AlgoliaSearchBox.defaultProps = {
  algoliaIndexId: StringConstantsMixin.constants.ALGOLIA.INDEX,
  allowStringSearch: false,
  liveStringSearch: false,
  searchIconButton: true,
  weightResults: true,
  page: null
};

export default AlgoliaSearchBox;
